import { render, staticRenderFns } from "./AccountReceivableCard.vue?vue&type=template&id=254cb91a&"
import script from "./AccountReceivableCard.vue?vue&type=script&lang=js&"
export * from "./AccountReceivableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports